import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useAppContext } from "../AppContext";
import SearchInput from "./SearchInput";
import UsageIndicator from "./UsageIndicator";
import { getRouteMeta } from "../shell/routeMeta";

const getGreetingKey = (hour) => {
  if (hour < 6) return "shell.good_night";
  if (hour < 12) return "shell.good_morning";
  if (hour < 18) return "shell.good_afternoon";
  return "shell.good_evening";
};

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { currentUser, setMobileNavOpen } = useAppContext();
  const [scrolled, setScrolled] = useState(() => window.scrollY > 4);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const meta = getRouteMeta(location.pathname);
  const parentMeta = meta?.parent ? getRouteMeta(meta.parent) : null;

  let label = meta ? t(meta.label) : "";
  if (location.pathname === "/edituser") {
    const userId = new URLSearchParams(location.search).get("userId");
    label = userId === currentUser.user_id ? t("my_profile") : t("edit_user");
  }

  const firstName = (currentUser.name || "").split(" ")[0];
  const requestCount = currentUser.requests?.length || 0;

  return (
    <header id="header" className={scrolled ? "scrolled" : ""}>
      <button type="button" className="topbar-burger" onClick={() => setMobileNavOpen(true)} aria-label={t("shell.open_menu")}>
        <span /><span /><span />
      </button>

      <div className="topbar-title">
        {isHome ? (
          <div className="topbar-greeting">
            <span className="topbar-greeting-hello">{t(getGreetingKey(new Date().getHours()), { name: firstName })}</span>
            <span className="topbar-greeting-date">{moment().format("dddd D MMMM")}</span>
          </div>
        ) : meta && (
          <div className="crumbs">
            <span className="crumb-icon"><i className={meta.icon} /></span>
            {meta.section && <span className="crumb">{t(meta.section)}</span>}
            {parentMeta && (
              <NavLink to={meta.parent} className="crumb crumb-link">{t(parentMeta.label)}</NavLink>
            )}
            <span className="crumb current">{label}</span>
          </div>
        )}
      </div>

      <div className="topbar-actions">
        <SearchInput />
        <UsageIndicator />
        {requestCount > 0 && (
          <NavLink to="/requests" className="topbar-btn" title={t("requests")} aria-label={t("requests")}>
            <i className="icon-bell" />
            <span className="topbar-badge">{requestCount}</span>
          </NavLink>
        )}
      </div>
    </header>
  );
};

export default Header;
